/** Format Google Ads primary_status_reasons for display (matches legacy UI). */
export function formatStatusReasons(reasons: string[]): string {
	if (!reasons.length) return "";
	return reasons.join(", ").replace(/_/g, " ");
}
